<template>
  <div class="buttons">
    <button
      class="buttons__button button button_theme_primary"
      @click="getCall({ type: 'sale', text: 'Зафиксировать цену по акции' })"
    >
      Зафиксировать цену по акции
    </button>
    <button
      class="buttons__button button button_theme_white"
      @click="getCall({ type: 'sale', text: 'Хочу купить в рассрочку или кредит' })"
    >
      Хочу купить в рассрочку или кредит
    </button>
  </div>
</template>

<script>
import Mixin from "@/common/mixin";

export default {
  name: "buttons",
  mixins: [Mixin],
};
</script>

<style lang="scss" scoped>
@import "@/styles/constants.scss";

.buttons {
  display: flex;
  justify-content: center;
  gap: 1em;
  margin-top: 2.25em;
  width: 100%;
  padding-right: 1.75em;

  &__button {
    font-size: 0.8em;
    border-radius: 1.25em;
    padding: 1.4em 2em;
    text-transform: uppercase;
    font-weight: 700;
    white-space: nowrap;
  }
}

@media (max-width: 800px) {
  .buttons {
    flex-direction: column;
    margin-top: 1em;
    padding: 0;

    &__button {
      font-size: 0.9em;
      width: 100%;
    }
  }
}
</style>
